<template>
    <div class="text-field-with-extra-label">
        <label :for="name" v-bind:style="{fontWeight: fontWeight }">{{ labelPartOne }} <span style="white-space:nowrap;">{{ labelPartTwo }} <span id="tooltip-id" ref="tooltip-id" @mouseover="showTooltip" @mouseleave="hideTooltip" v-show="hasTooltip" class="label-tooltip rounded-circle">?<span v-show="activeTooltip" class="calc-tooltip">{{ tooltipText }}<div class="arrow-down"></div></span></span></span></label>
        <div class="input-group mb-3">
            <input ref="text-field-input" type="text" v-model="displayValue" v-on:blur="focusOut" v-on:focus="saveCurrentValue" v-on:change="validateValue" class="form-control text-field-input" :id="name" :placeholder="placeholder" :aria-label="placeholder" aria-describedby="basic-addon1">
            <div class="input-group-append">
                <span class="input-group-text" id="basic-addon1">{{ extraLabel }}</span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "text-field-with-extra-label",
        data () {
            return {
                activeTooltip: false,
                currentValue: '',
                activeInput: false
            }
        },
        props: {
            name: String,
            value: Number,
            placeholder: String,
            label: String,
            extraLabel: String,
            isBoldFont: Boolean,
            hasTooltip: Boolean
        },
        computed: {
            labelPartOne: function () {
                return this.label.substring(0, this.label.lastIndexOf(" ") + 1);
            },
            labelPartTwo: function () {
                return this.label.substring(this.label.lastIndexOf(" ") + 1);
            },
            fontWeight: function () {
                return this.isBoldFont ? 'bold' : 'normal';
            },
            displayValue: {
                get: function () {
                    if (this.activeInput) {
                        return this.value;
                    } else {
                        var currencyValue = this.value.toLocaleString('en-US',{useGrouping:true});
                        return currencyValue;
                    }
                },
                set: function (newValue) {
                    this.value = newValue.replace(",", "");
                }
            },
            tooltipText: function () {
                var helpText = "";

                switch (this.name) {
                    case 'Vacancy-Period':
                        helpText = "This is an estimate of how many weeks the property might not have a tenant " +
                            "in the first year. An average vacancy of 2 weeks has been adopted as a default value";
                        break;
                    case 'Loan-Term':
                        helpText = "The amount of years when the loan is due to be paid off. " +
                            "Thirty (30) years has been adopted as a default value";
                        break;
                }

                return helpText;
            }
        },
        methods: {
            showTooltip: function () {
                this.activeTooltip = true;
            },
            hideTooltip: function () {
                this.activeTooltip = false;
            },
            saveCurrentValue: function () {
                this.currentValue = this.value;

                if (this.value === 0) {
                    this.value = '';
                }

                var valueLength = this.value.toString().length;
                var textFieldInput = this.$refs['text-field-input'];
                setTimeout(function() {
                    textFieldInput.setSelectionRange(valueLength, valueLength);
                }, 0);

                this.activeInput = true;
            },
            focusOut: function () {

                if (this.value === '') {
                    this.value = 0;
                }

                this.activeInput = false;
            },
            validateValue: function () {

                if (this.value >= 0 && !isNaN(this.value)) {
                    if (this.extraLabel !== '%') {
                        this.value = Math.round(this.value);
                    } else if (this.extraLabel === '%') {
                        if (Math.floor(this.value) !== Number(this.value)) {
                            if (this.value.toString().split(".")[1].length > 2) {
                                this.value = Number(Math.round(Number(this.value+'e'+2))+'e-'+2);
                            }
                        }
                    }
                    this.currentValue = this.value;
                    this.$emit('calc', this.value);
                } else {
                    this.value = this.currentValue;
                }
            }
        },
        mounted() {

            let $vm = this;
            var tooltip = this.$refs['tooltip-id'];
            tooltip.addEventListener('touchstart', function () {
                $vm.activeTooltip = !$vm.activeTooltip;
            })
        }
    }
</script>

<style scoped>
    label {
        float: left;
        width: 48% !important;
        font-size: 20px;
        color: #465978;
        margin-top: -7px;
        margin-bottom: 15px;
    }

    .input-group {
        width: 50%;
        margin-left: auto;
        font-size: 20px;
        margin-top: 0;
        align-self: start
    }

    .input-group-text {
        font-weight: bold;
        background-color: #fff;
        color: #465978;
        font-size: 18px;
        height: 38px;
    }

    .text-field-with-extra-label {
        width: 85%;
        margin: 0 auto;
        font-size: 20px;
        display: flex;
    }

    .text-field-input {
        background-color: #fff;
        text-align: right;
        font-size: 20px;
    }

    .label-tooltip {
        background-color: #ee3124;
        width: 20px;
        border-radius: 50%;
        color: white;
        font-weight: bold;
        font-size: 16px;
        display: inline-block;
        font-family: 'Roboto', Arial, serif;
        position: relative;
        cursor: pointer;
        height: 0;
        padding: 10px 0%;
        line-height: 0;
        text-align: center;
    }

    .calc-tooltip {
        position: absolute;
        z-index: 99;
        top: -60px;
        left: 0px;
        background-color: #465978;
        height: 58px;
        width: 250px;
        color: #fff;
        line-height: 16px;
        padding: 8px;
        opacity: 0.9;
        margin-left: -475%;
        overflow: hidden;
        white-space: normal;
    }

    .arrow-down {
        width: 0;
        height: 0;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-top: 10px solid black;
        margin-left: 88px;
        margin-bottom: 0;
        margin-top: 5px;
    }

    .vacancy-period .calc-tooltip {
        width: 260px;
        height: 122px;
        top: -123px;
        margin-left: -405%;
    }

    .vacancy-period .arrow-down {
        margin-left: 73px;
    }

    .loan-term .calc-tooltip {
        width: 260px;
        height: 90px;
        top: -91px;
        margin-left: -475%;
    }

    .loan-term .arrow-down {
        margin-left: 88px;
    }

    @media (min-width: 1024px) {
        .text-field-with-extra-label {
            margin-bottom: 12px;
        }

        label {
            margin-bottom: 0;
        }
    }

    @media (max-width: 435px) {

        .input-group {
            width: 50%;
        }
    }
</style>


// WEBPACK FOOTER //
// src/Components/TextFieldWithExtraLabel.vue